/* eslint-disable prettier/prettier */
import { NavigateFunction, RelativeRoutingType } from 'react-router-dom';

interface NavigateProps {
  path:
    | any
    | {
        pathname: string;
        search: string;
        hash: string;
      };
  options: {
    replace?: boolean;
    state?: any;
    preventScrollReset?: boolean;
    relative?: RelativeRoutingType;
    unstable_flushSync?: boolean;
    unstable_viewTransition?: boolean;
  };
}

let navigate: NavigateFunction | null = null;

export function setNavigateFunction(navigateFunction: NavigateFunction) {
  navigate = navigateFunction;
  window.navigate = navigateFunction;
}

export function navigateTo(path: NavigateProps['path'], params?: NavigateProps['options']): void {
  if (navigate) {
    if (typeof path === 'string' && path?.includes('://')) {
      const url = new URL(path);
      path = url?.pathname + url?.search;
    }
    navigate(path, params ?? {});
  } else {
    console.error('Navigate function not set');
  }
}
